<template>
    <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs6 sm4 md3 lg2 d-flex>
                    <lookup ref="makeLookup" v-model="makeLookup" :placeholder="$t('message.177')" document="make" query="make:*" item-text="make" item-value="make"></lookup>
                </v-flex>
                <v-flex xs6 sm4 md3 lg2 d-flex>
                    <lookup ref="modelLookup" v-model="modelLookup" :placeholder="$t('message.174')" document="makemodel" item-text="model" item-value="model"></lookup>
                </v-flex>
                <v-flex xs6 sm4 md3 lg2 d-flex>
                    <lookup ref="capacityLookup" v-model="capacityLookup" :placeholder="$t('message.258')" document="makemodelcapacity" item-text="capacity" item-value="capacity"></lookup>
                </v-flex>
                <v-flex xs6 sm4 md3 lg2 d-flex>
                    <lookup ref="fuelLookup" v-model="fuelLookup" :placeholder="$t('message.203')" document="makemodelcapacityfuel" item-text="fuel" item-value="fuel"></lookup>
                </v-flex>
                <v-flex xs6 sm4 md3 lg2 d-flex>
                    <lookup ref="yearLookup" v-model="yearLookup" :placeholder="$t('message.102')" document="makemodelcapacityfuelyear" item-text="year" item-value="year"></lookup>
                </v-flex>
                <v-flex xs6 sm4 md3 lg2 d-flex>
                    <lookup ref="bodyLookup" v-model="bodyLookup" :placeholder="$t('message.265')" document="makemodelcapacityfuelyearbody" item-text="body" item-value="body"></lookup>
                </v-flex>
            </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'SearchWidget',
  props: {
    value: String
  },
  data () {
    return {
      loading: false,
      makeLookup: 'Arbarth',
      modelLookup: null,
      capacityLookup: null,
      fuelLookup: null,
      yearLookup: null,
      bodyLookup: null,
      items: [],
      query: null
    }
  },
  mounted () {
    if (this.$route.params.make) {
      this.makeLookup = this.$route.params.make
      this.$refs.makeLookup.setValue(this.$route.params.make)
    }
  },
  methods: {
    getQuery () {
      let terms = []
      if (this.makeLookup) {
        terms.push(`make:"${this.makeLookup}"`)
      }
      if (this.modelLookup) {
        terms.push(`model:"${this.modelLookup}"`)
      }
      if (this.capacityLookup) {
        terms.push(`capacity:${this.capacityLookup}`)
      }
      if (this.fuelLookup) {
        terms.push(`fuel:"${this.fuelLookup}"`)
      }
      if (this.yearLookup) {
        terms.push(`years:${this.yearLookup}`)
      }
      if (this.bodyLookup) {
        terms.push(`body:"${this.bodyLookup}"`)
      }
      return terms
    },
    onLookupChange () {
      let terms = this.getQuery()
      if (terms) {
        this.$emit('input', terms.join(' '))
      } else {
        this.$emit('input', null)
      }
    }
  },
  watch: {
    makeLookup (value) {
      this.modelLookup = null
      this.$refs.modelLookup.clear()
      this.capacityLookup = null
      this.$refs.capacityLookup.clear()
      this.fuelLookup = null
      this.$refs.fuelLookup.clear()
      this.yearLookup = null
      this.$refs.yearLookup.clear()
      this.bodyLookup = null
      this.$refs.bodyLookup.clear()
      if (value) {
        this.$refs.modelLookup.remoteLookup(`make:"${value}"`)
      } else {
        this.makeLookup = null
      }
      this.onLookupChange()
    },
    modelLookup (value) {
      this.capacityLookup = null
      this.$refs.capacityLookup.clear()
      this.fuelLookup = null
      this.$refs.fuelLookup.clear()
      this.yearLookup = null
      this.$refs.yearLookup.clear()
      this.bodyLookup = null
      this.$refs.bodyLookup.clear()
      if (value) {
        this.$refs.capacityLookup.remoteLookup(`make:"${this.makeLookup}" model:"${value}"`)
      } else {
        this.modelLookup = null
      }
      this.onLookupChange()
    },
    capacityLookup (value) {
      this.fuelLookup = null
      this.$refs.fuelLookup.clear()
      this.yearLookup = null
      this.$refs.yearLookup.clear()
      this.bodyLookup = null
      this.$refs.bodyLookup.clear()
      if (value) {
        this.$refs.fuelLookup.remoteLookup(`make:"${this.makeLookup}" model:"${this.modelLookup}" capacity:${this.capacityLookup}`)
      } else {
        this.capacityLookup = null
      }
      this.onLookupChange()
    },
    fuelLookup (value) {
      this.yearLookup = null
      this.$refs.yearLookup.clear()
      this.bodyLookup = null
      this.$refs.bodyLookup.clear()
      if (value) {
        this.$refs.yearLookup.remoteLookup(`make:"${this.makeLookup}" model:"${this.modelLookup}" capacity:${this.capacityLookup} fuel:"${value}"`)
      } else {
        this.fuelLookup = null
      }
      this.onLookupChange()
    },
    yearLookup (value) {
      this.bodyLookup = null
      this.$refs.bodyLookup.clear()
      if (value) {
        this.$refs.bodyLookup.remoteLookup(`make:"${this.makeLookup}" model:"${this.modelLookup}" capacity:${this.capacityLookup} fuel:"${this.fuelLookup}" year:${value}`)
      } else {
        this.yearLookup = null
      }
      this.onLookupChange()
    },
    bodyLookup (value) {
      if (!value) {
        this.bodyLookup = null
      }
      this.onLookupChange()
    }
  }
}
</script>

<style scoped>

</style>
